module.exports = __webpack_public_path__ + "img/banner-cup-content.2c030be7.svg";